import type { ReactNode } from 'react';

import type { Permission } from './permissions.catalog';
import { usePermissions } from './usePermissions';

type Props = {
  children: ReactNode;
  permission?: Permission;
  any?: Permission[];
  all?: Permission[];
  fallback?: ReactNode;
};
export const Can = ({ children, permission, any, all, fallback = null }: Props) => {
  const { can, canAny, canAll } = usePermissions();
  if (permission && !can(permission)) return <>{fallback}</>;
  if (any && !canAny(any)) return <>{fallback}</>;
  if (all && !canAll(all)) return <>{fallback}</>;
  return <>{children}</>;
};
